function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 22,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#26A17B",
  fillRule: "evenodd",
  d: "M24 48C10.745 48 0 37.255 0 24S10.745 0 24 0s24 10.745 24 24-10.745 24-24 24zm2.883-27.31v-3.55h8.121v-5.412H12.893v5.412h8.12v3.548c-6.6.303-11.563 1.611-11.563 3.177s4.964 2.873 11.564 3.177v11.373h5.869V27.039c6.59-.303 11.541-1.61 11.541-3.174 0-1.564-4.952-2.871-11.541-3.175zm0 5.384v-.003c-.165.012-1.015.063-2.913.063-1.515 0-2.581-.044-2.956-.063v.005c-5.832-.256-10.185-1.272-10.185-2.487 0-1.213 4.352-2.229 10.184-2.49v3.966c.381.027 1.473.091 2.982.091 1.811 0 2.718-.075 2.888-.09v-3.964c5.82.26 10.162 1.275 10.162 2.487 0 1.215-4.342 2.228-10.162 2.486z",
  clipRule: "evenodd"
});

function SvgUsdt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "647565869167b7ab0380e151b4f63b70.svg";
export { SvgUsdt as ReactComponent };